angular.module('salesPath.outer')
/**
 *
 * obiekt opisujący dostępność usługi
 * @param {Object=} data dane wejściowe (klucze jak własności klasy)
 */
.factory('IHestiaAvailabilityModel', [ function() {

    var IHestiaAvailabilityModel = function(data)
    {
      data = data || {};
      /**
       * nazwa klasy serwisu (js/services/...)
       * @type string
       */
      this.serviceClassName = data.serviceClassName || null;
      /**
       * podZasób
       * @type string
       */
      this.subResource = data.subResource || null;
      /**
       * nazwa usługi (get, post etc.)
       * @type string
       */
      this.method = data.method || null;
      /**
       * czy aktywna
       * @type boolean
       */
      this.available = (typeof data.available === 'boolean') ? data.available : true;
    };

    return IHestiaAvailabilityModel;
  }]);